import axios from 'axios';
import qs from "qs";
import store from '../store'
import { ElMessage } from 'element-plus';
import vuex from 'vuex'
// axios.defaults.headers['Cache-Control'] = 'max-age=0'
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'

const baseURL = process.env.VUE_APP_BASE_API;

const instance = axios.create({
    baseURL, // baseURL: 'http://192.168.0.161:8081/dev-api/',
    timeout: 1000 * 3000,
});

// 存储刷新Token的Promise，用于处理并发请求
console.log(process.env.VUE_APP_BASE_API, '看一下运行环境');

const requestMethod = {
    get(url, params) {
        return new Promise((resolve, reject) => {
            console.log(window.$stitchingPath(url, params), 'window.$stitchingPath(url, params)')
            instance.get(window.$stitchingPath(url, params)).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },

    post(url, params) {
        return new Promise((resolve, reject) => {
            instance.post(url, qs.stringify(params)).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },

    protists: instance,
    baseURL
};

["get", "post", "all"].forEach(item => {
    window['$' + item] = instance[item];
});

["all", "spread"].forEach(item => {
    window['$' + item] = axios[item];
});


/**
 * @author: kxf
 * @createDate: 2025/10/16
 * @description: 请求拦截器
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
const interceptorsRequestSuccess = function (config) {
    console.log("请求拦截器成功", config)
    // 在发送请求之前做些什么
    config.headers.satoken = store.state.saToken;
    return config;
}

const interceptorsRequestError = function (error) {
    console.log("请求拦截器错误", error)
    // 对请求错误做些什么
    return Promise.reject(error);
}


/**
 * @author: kxf
 * @createDate: 2025/10/16
 * @description: 响应拦截器
 * 入参解释:
 * 返回值解释:
 * @steps：
 */
const interceptorsResponseSuccess = async function (response) {
    console.log("响应拦截器成功", response)
    if(response.status === 200 && response.data.code === 401) {
        ElMessage.error('登录过期，请重新登录');
        store.commit('setSaToken', '');
        setTimeout(() => {
            window.location.href = '/';
        }, 1000)
    }
    return Promise.resolve(response.data);
};

const interceptorsResponseError = async function (error) {
    console.log("响应拦截器错误", error)
    return Promise.reject(error);
}

instance.interceptors.request.use(interceptorsRequestSuccess, interceptorsRequestError);
instance.interceptors.response.use(interceptorsResponseSuccess, interceptorsResponseError);

export default requestMethod;
